import { useRef } from "react";
import { getUniqueId } from "./getUniqueId";

export interface UseUniqueIdReturnType {
  uniquePrefix: string;
  uid: (suffix: string) => string;
}

export function useUniqueId(prefix: string): UseUniqueIdReturnType {
  const uniqueIdRef = useRef<UseUniqueIdReturnType>();
  if (!uniqueIdRef.current) {
    const uniquePrefix = getUniqueId(prefix);
    const returnObj = {
      uniquePrefix: uniquePrefix,
      uid(suffix: string) {
        return `${uniquePrefix}-${suffix}`;
      },
    };
    uniqueIdRef.current = returnObj;
  }
  return uniqueIdRef.current;
}
